import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateOptionItemSquare,
  DominateOptionItemSquareList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateOptionItemSquare';
import { CONTROL_RESPONSE_OPTIONS } from '@/pages/Onboarding/options/ControlResponse/CONTROL_RESPONSE_OPTIONS';
import { ControlResponseOptionIdType } from '@/pages/Onboarding/options/ControlResponse/types';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../../OwnAI_Dominate/components/Title';
import { DominateFooter } from '../../components/DominateFooter';
import { LayoutDataType } from '../../types';

import { PageStyles } from './ControlResponse.styles';

export const ScreenControlResponse: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'ControlResponse',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const controlResponse = form.watch('control_response');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['control_response']>,
  ) => {
    form.setValue('control_response', option.id);
  };

  const getImageSrc = (id: ControlResponseOptionIdType) => {
    return `${S3_BUCKET_URL}/layout-own-ai-dominate-v2/control-response/${id}.png`;
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        control_response: controlResponse,
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation />
      <OwnAiTitle>How do you handle being told what to do?</OwnAiTitle>

      <IonContent>
        <DominateOptionItemSquareList>
          {CONTROL_RESPONSE_OPTIONS.map(
            (option: OnbOptionType<ControlResponseOptionIdType>) => (
              <DominateOptionItemSquare
                key={option.id}
                isSelected={controlResponse === option.id}
                onClick={() => handleSelect(option)}
                bgSrc={getImageSrc(option.id)}
                title={option.title}
                TEST_ID={`control-response-${option.id}`}
              />
            ),
          )}
        </DominateOptionItemSquareList>
      </IonContent>

      {controlResponse && (
        <DominateFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
          buttonClassName={'page-footer'}
          quoteText="Interesting. I prefer obedience. But I enjoy a challenge"
          buttonText="I'll follow"
          variant="with-quotes"
        />
      )}
    </PageStyles>
  );
};
